export default __webpack_public_path__ + "static/media/CreateMainSubject.102dc898.mp4";